<div id="background">
  <img src="assets/images/chapps-logo.png" alt="Chapps"/>
  <div class="card card-cascade narrower mb-4">
    <div class="card-body">
      <div [hidden]="errorMessage == null">
        <div class="alert alert-danger font-small" role="alert" [innerHtml]="errorMessage"></div>
        <div class="justify-content-center mt-4">
          <div class="d-flex justify-content-center mt-4">                
            <button type="submit"  class="btn btn-amber" mdbRippleRadius (click)="reidirectToLogin()">
              {{ Localization.Login | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="page-spinner" *ngIf="isLogInProccessing">
  <mdb-spinner spinnerType="big" spinnerColor="blue"></mdb-spinner>
</div>